export default "__VITE_ASSET__8b45ddaa__"